import { i18n } from '../plugins/i18n'

export const week = [
  'sunday', 'monday','tuesday','wednesday','thursday','friday','saturday',
]

export const defaultRegularHours = week.map(w => {
  return {
    periods: [],
    wday: w
  }
})

export const defaultHolidayRegularHour = { isNotSet: true, periods: [] }
export const defaultDayBeforeHolidayRegularHour = { isNotSet: true, periods: [] }

export const bulkEditDefaultRegularHours = week.map(w => {
  return {
    attributes: {
      open: false,
      periods: [],
      wday: w
    }
  }
}).map(v => {
  v.attributes.noChange = true
  return v
})

// 24時間営業かどうかを返す
export const is24 = (period) => {
  return (period.openTime === '00:00' && period.closeTime === '24:00')
    || period.openTime === '00:00' && period.closeTime === '00:00'
}

export const displayHour = (type) => (dayOfWeek) => {
  if (type === 'regularHour' && dayOfWeek == null) return i18n.t('models.storeRegularHour.regularHoliday')

  if (dayOfWeek.periods.length === 0) {
    return type === 'moreHour' ? i18n.t('models.moreHour.notSet') : i18n.t('models.storeRegularHour.regularHoliday')
  }
  if (is24(dayOfWeek.periods[0])) {
    return i18n.t('models.storeRegularHour.open24hours')
  }
  return dayOfWeek.periods.map(p => `${p.openTime} - ${p.closeTime}`).join(' / ')
}

// periodの順番がバラバラなので時間順にソートする
export const periodCompareFn = (a,b) => {
  const firstStartHour = a.openTime.split(':')[0]
  const secondStartHour = b.openTime.split(':')[0]
  const firstStartMinute = a.openTime.split(':')[1]
  const secondStartMinute = b.openTime.split(':')[1]
  const hourDiff = Number(firstStartHour) - Number(secondStartHour)
  const minuteDiff = Number(firstStartMinute) - Number(secondStartMinute)

  return hourDiff === 0 ? minuteDiff : hourDiff
}

export const formatDisplayHours = (arr) => {
  const crossDayOfWeekIndexes = []

  return arr
    // 曜日順でソート
    .sort((a,b) => Number(week.indexOf(a.wday) > week.indexOf(b.wday)))
    // 日付跨ぎの処理
    .map((week, i, weeks) => {
      if (week.periods.length === 0) return week

      const period = week.periods.at(-1)
      if (period.closeTime !== '24:00' || is24(period)) return week

      const nextDayOfWeekIndex = i === (weeks.length - 1) ? 0 : i + 1
      const nextDayOfWeekPeriod = weeks[nextDayOfWeekIndex].periods[0]
      if (nextDayOfWeekPeriod == null
        || nextDayOfWeekPeriod.openTime !== '00:00'
        || is24(nextDayOfWeekPeriod)
      ) return week

      // 日付跨いだperiodを後で消すために、indexを保存しておく
      crossDayOfWeekIndexes.push(nextDayOfWeekIndex)

      period.closeTime = nextDayOfWeekPeriod.closeTime
      return week
    })
    // 跨いだperiodを消す
    .map((week, i) => {
      if (crossDayOfWeekIndexes.includes(i)) {
        week.periods.shift()
      }
      return week
    })
}
